module.exports = function() {
  return new Worker(__webpack_public_path__ + "559256dc812e37cc8bb5.worker.js");
};